const semanticClassNames = {
  root: 'anchor-menu',
  menuItem: 'anchor-menu__item',
  itemLabel: 'anchor-menu__label',
} as const;

export default semanticClassNames;
